import React from 'react';
import { Link } from 'react-router-dom';

function ServiceBox(props) {
    if (props.image) {
        return (
            <div className="service--box-row service--box-hover">
                <Link to="/services" className="service--box-link">
                    <div className="service--box-img-col service--box-img-hover">
                        <img className="service--box-img" src={props.image.src} alt={props.image.alt} />
                        <div className="service--box-img-overlay"></div>
                    </div>
                    <div className="service--box-text-col">
                        <h4>{props.heading}</h4>
                        <p>{props.paragraph}</p>
                    </div>
                </Link>
            </div>
        );
    } else {
        return (
            <div className={`service--box-icon`}>
                <div className="icon">{props.icon}</div>
                <div className="text">
                    <h4>{props.title}</h4>
                </div>
            </div>
        );
    }
}

export default ServiceBox;
